/**
 * Styles for ConversationCard component
 */

import type { SxProps, Theme } from "@mui/material";

export const cardSx: SxProps<Theme> = {
  mb: 0,
  transition: "all 0.3s ease",
  backgroundColor: "#ffffff",
  boxShadow: "none !important",
};

export const cardContentSx: SxProps<Theme> = {
  border: "1px solid #ddd",
  borderRadius: 2,
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1) !important",
  p: 2,
  gap: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
};

export const userQueryRowSx: SxProps<Theme> = {
  height: "fit-content",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: 1,
};

export const userQueryBoxSx: SxProps<Theme> = {
  width: "100%",
  padding: "8px 16px",
  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  backgroundColor: "#eeeeee",
  borderRadius: "8px",
  marginTop: "-2px",
};

export const userQueryTypographySx: SxProps<Theme> = {
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  borderRadius: "8px",
  fontWeight: 500,
  fontSize: "0.95rem",
  lineHeight: 1.5,
  color: "#495057",
  width: "fit-content",
};

export const motionDivStyle = { width: "100%" } as const;
